import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // ✅ this must come after importing App
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./Auth/AuthContext";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "./Auth/ThemeContext"; // or your path

ReactDOM.createRoot(document.getElementById("root")).render(
  <ThemeProvider>
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="center" />
        <App />
      </AuthProvider>
    </BrowserRouter>
  </ThemeProvider>
);
